import { z } from 'zod';
export const createShareclassSchema = z.object({
    fund_name: z.string(),
    shareclass_code: z.string(),
    shareclass_sleeve: z.string(),
    isin: z.string(),
});
